import React, { ChangeEvent } from 'react';
import { useParams } from 'react-router-dom';
import {
  doc,
  setDoc,
  type DocumentReference,
} from 'firebase/firestore';
import { useFirestore, useFirestoreDoc } from 'reactfire';

import { useSuperadmin } from '../user';
import Loading from '../Loading';
import { defaultMaxGroups, type UserState } from '../common/firestoreTypes';
import UserGroupList from '../UserGroupList';

export default function SuperUserFrame() {
  const firestore = useFirestore();
  const isSuperadmin = useSuperadmin();
  const { uid } = useParams();
  const userStateRef = doc(firestore, `userStates/${uid}`) as DocumentReference<UserState>;
  const { data, status, error } = useFirestoreDoc<UserState>(userStateRef);
  const userState = data?.data();

  if (!uid || !isSuperadmin) {
    return <h2>Not found</h2>;
  }

  if (error) {
    console.error('Error loading user state:', error);
    return <h2>Error loading user state: { String(error) } </h2>;
  }

  if (status === 'loading') {
    return (
      <Loading />
    );
  }

  const userMaxGroups = userState?.maxGroups ?? 0;

  const onChangeMaxGroups = async (event: ChangeEvent<HTMLInputElement>) => {
    const maxGroups = Number(event.target.value);
    await setDoc(
      doc(firestore, `userStates/${uid}`),
      { maxGroups },
      { merge: true },
    );
  };

  return (
    <div>
      <div>
        <b>Max groups (stored):</b>
        &ensp;
        <input
          type="number"
          step={1}
          min={1}
          value={userMaxGroups || 0}
          onChange={onChangeMaxGroups}
        />
        &ensp;
        Effective max: {Math.max(userMaxGroups || 0, defaultMaxGroups)}
      </div>
      <br />
      <div>
        <b>Groups:</b>
        <UserGroupList uid={uid} showHeader={false} />
      </div>
      <br />
    </div>
  );
}
